export const LogsIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7555_89294)">
        <path
          d="M13.2151 7.21484H9.27757C8.97007 7.21484 8.71507 6.95984 8.71507 6.65234C8.71507 6.34484 8.97007 6.08984 9.27757 6.08984H13.2151C13.5226 6.08984 13.7776 6.34484 13.7776 6.65234C13.7776 6.95984 13.5301 7.21484 13.2151 7.21484Z"
          fill="#05796B"
        />
        <path
          d="M5.33968 7.78526C5.19718 7.78526 5.05468 7.73276 4.94218 7.62026L4.37968 7.05773C4.16218 6.84023 4.16218 6.48023 4.37968 6.26273C4.59718 6.04523 4.95718 6.04523 5.17468 6.26273L5.33968 6.42773L6.62968 5.13773C6.84718 4.92023 7.20718 4.92023 7.42468 5.13773C7.6422 5.35523 7.6422 5.71523 7.42468 5.93273L5.73718 7.62026C5.63218 7.72526 5.48968 7.78526 5.33968 7.78526Z"
          fill="#05796B"
        />
        <path
          d="M13.2151 12.4648H9.27757C8.97007 12.4648 8.71507 12.2098 8.71507 11.9023C8.71507 11.5948 8.97007 11.3398 9.27757 11.3398H13.2151C13.5226 11.3398 13.7776 11.5948 13.7776 11.9023C13.7776 12.2098 13.5301 12.4648 13.2151 12.4648Z"
          fill="#05796B"
        />
        <path
          d="M5.33968 13.0352C5.19718 13.0352 5.05468 12.9827 4.94218 12.8702L4.37968 12.3077C4.16218 12.0902 4.16218 11.7302 4.37968 11.5127C4.59718 11.2952 4.95718 11.2952 5.17468 11.5127L5.33968 11.6777L6.62968 10.3877C6.84718 10.1702 7.20718 10.1702 7.42468 10.3877C7.6422 10.6052 7.6422 10.9652 7.42468 11.1827L5.73718 12.8702C5.63218 12.9752 5.48968 13.0352 5.33968 13.0352Z"
          fill="#05796B"
        />
        <path
          d="M11.25 17.0625H6.75C2.6775 17.0625 0.9375 15.3225 0.9375 11.25V6.75C0.9375 2.6775 2.6775 0.9375 6.75 0.9375H11.25C15.3225 0.9375 17.0625 2.6775 17.0625 6.75V11.25C17.0625 15.3225 15.3225 17.0625 11.25 17.0625ZM6.75 2.0625C3.2925 2.0625 2.0625 3.2925 2.0625 6.75V11.25C2.0625 14.7075 3.2925 15.9375 6.75 15.9375H11.25C14.7075 15.9375 15.9375 14.7075 15.9375 11.25V6.75C15.9375 3.2925 14.7075 2.0625 11.25 2.0625H6.75Z"
          fill="#05796B"
        />
      </g>
      <defs>
        <clipPath id="clip0_7555_89294">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
